import { Col, Row, Table, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import { Modal } from "antd";
import { useMutation } from "react-query";
import { useDispatch, useSelector } from "react-redux";
import { LinkOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import HeadingBack from "../../../component/HeadingBack";
import AbhaLinkedFilter from "../AbhaFilter";
import moment from "moment";
import { usePermission, useRights } from "../../../hooks/usePermission";
import { KeyMaterialRequst } from "../../../redux/Services/AbhaServices";
import { DashboardServices } from "../../../redux/Services";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { AntLoadingButton } from "../../../component/LoadingButton";
const ConsentArtifactDetails = () => {
  const permission = usePermission("HIU Dashboard", "List");
  // Pulling data starts a new health information request (needs Add)
  const rights = useRights("HIU Dashboard");
  const navigate = useNavigate();
  dayjs.extend(utc);
  dayjs.extend(timezone);
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [total, setTotal] = useState(0);
  const [filter, setFilter] = useState({});
  const ConsentArtifactDetails = useSelector(
    (state) => state.dashboard.ConsentArtifactDetails || []
  );
  const totalConsentArtifactDetails = useSelector(
    (state) => state.dashboard.totalConsentArtifactDetails || ""
  );
  const { mutate: fetchConsentArtifactDetails, isLoading } = useMutation(
    (data) => dispatch(DashboardServices.fetchConsentArtifactDetails(data))
  );
  const { mutateAsync: KeyMaterialRequest, isLoading: addLoading } = useMutation(
    (data) => dispatch(KeyMaterialRequst(data, navigate))
  );
  const [modal1Open, setModal1Open] = useState(false);
  const [raw, setRaw] = useState({});
  const [currentDate, setCurrentDate] = useState(
    moment().format("YYYY-MM-DD HH:mm:ss")
  );
  const [keyMaterial, setKeyMaterial] = useState({
    privateKey: "DpstJVIUMbG4W0oQAwvke7BHqdmS/6XMC733YMjDaDk=",
    publicKey:
      "BEzf4ciIL58K7d3JCIzp18uI5dq4KsNXpJegmgtP/e7pYLDlKF8Hpv7rWd7T0YFVh+FbZVJSkCiWsh7iF2CQ3Co=",
    x509PublicKey:
      "MIIBMTCB6gYHKoZIzj0CATCB3gIBATArBgcqhkjOPQEBAiB/////////////////////////////////////////7TBEBCAqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqYSRShRAQge0Je0Je0Je0Je0Je0Je0Je0Je0Je0Je0JgtenHcQyGQEQQQqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqq0kWiCuGaG4oIa04B7dLHdI0UySPU1+bXxhsinpxaJ+ztPZAiAQAAAAAAAAAAAAAAAAAAAAFN753qL3nNZYEmMaXPXT7QIBCANCAARM3+HIiC+fCu3dyQiM6dfLiOXauCrDV6SXoJoLT/3u6WCw5ShfB6b+61ne09GBVYfhW2VSUpAolrIe4hdgkNw",
    nonce: "6IUe5wpHdJF/njHrhD9viI4defvinLoHsJXhcOkdl7s="
  });
  const handleNotify = (item) => {
    var rawData = item?.response_raw_data
      ? JSON.parse(item?.response_raw_data)
      : null;
    var healthId = rawData?.consent?.consentDetail?.patient?.id || "{}";

    let payload = {
      hiRequest: {
        consent: {
          id: `${rawData?.consent?.consentDetail?.consentId || ""}`
        },
        dateRange: {
          from: `${rawData?.consent?.consentDetail?.permission.dateRange?.from}`,
          to: `${rawData?.consent?.consentDetail?.permission?.dateRange?.to}`
        },
        dataPushUrl: process.env.REACT_APP_CALLBACKURL,
        expiry: rawData?.consent?.consentDetail?.permission?.dataEraseAt
        //   rawData?.consent?.consentDetail?.consentId,
        // keyMaterial: {
        //   cryptoAlg: "ECDH",
        //   curve: "Curve25519",
        //   dhPublicKey: {
        //     expiry: moment(),
        //     parameters: "Curve25519/32byte random key",
        //     keyValue: keyMaterial?.x509PublicKey
        //   },
        //   nonce: keyMaterial?.nonce
        // }
      }
    };
    let _data = { ...payload };
    _data.customToken = true;

    return KeyMaterialRequest(_data);
  };
  const expireDateTime = (expiryDate) => {
    const date = moment(expiryDate, "YYYY-MM-DD HH:mm:ss");
    if (date.isBefore(currentDate)) {
      return true;
    } else {
      return false;
    }
  };
  useEffect(() => {
    const payload = {
      page,
      limit,
      ...filter
    };
    fetchConsentArtifactDetails(payload);
  }, [page, limit, filter]);

  const columns = [
    {
      title: "S.No.",
      dataIndex: "sno",
      key: "sno",
      className: "table_first_col",
      render: (value, item, index) => (page - 1) * limit + index + 1
    },
    {
      title: "Action (Pull Data)",
      dataIndex: "action",
      key: "actiion",
      className: "abha-link-action",
      render: (value, item, index) =>
        item?.consent_status == "GRANTED" && rights.Add ? (
          <>
            {" "}
            <Tooltip placement="top" title={"Pull Data"}>
              <AntLoadingButton
                className="view-btn"
                type="primary"
                onClick={() => handleNotify(item || {})}
              >
                <LinkOutlined />
              </AntLoadingButton>
            </Tooltip>
          </>
        ) : null
    },
    // {
    //     title: 'Log Id',
    //     dataIndex: 'id',
    //     key: 'id',
    //     className: 'table_status_col',

    // },

    {
      title: "Artifact Id",
      dataIndex: "consent_artifact_id",
      key: "id",
      className: "text-capitalize"
    },

    // {
    //     title: 'Patient Name',
    //     dataIndex: 'response_raw_data',
    //     key: 'response_raw_data',
    //     className: 'text-capitalize',
    //     render: (value, item, index) => {
    //         const data = item?.response_raw_data ? JSON.parse(item?.response_raw_data) : null;

    //         return (
    //             data ?
    //                 <span>
    //                     {/* {data.consent?.consentDetail?.patient?.id} */}
    //                     Test
    //                 </span>
    //                 : null
    //         )
    //     }
    // },
    {
      title: "ABHA Address",
      dataIndex: "response_raw_data",
      key: "response_raw_data",
      className: "text-capitalize",
      render: (value, item, index) => {
        const data = item?.response_raw_data
          ? JSON.parse(item?.response_raw_data)
          : null;

        return data ? (
          <span>{data.consent?.consentDetail?.patient?.id}</span>
        ) : null;
      }
    },
    {
      title: "HIP Info",
      dataIndex: "response_raw_data",
      key: "response_raw_data",
      className: "text-capitalize",
      render: (value, item, index) => {
        const data = item?.response_raw_data
          ? JSON.parse(item?.response_raw_data)
          : null;
        return data ? (
          <span>
            {data.consent?.consentDetail?.hip?.name} (
            {data.consent?.consentDetail?.hip?.id})
          </span>
        ) : null;
      }
    },
    {
      title: "Care Context Count",
      dataIndex: "response_raw_data",
      key: "response_raw_data1",
      className: "text-capitalize",
      render: (value, item, index) => {
        const data = item?.response_raw_data
          ? JSON.parse(item?.response_raw_data)
          : null;
        return data ? (
          <span>{data.consent?.consentDetail?.careContexts.length}</span>
        ) : null;
      }
    },
    {
      title: "Requester",
      dataIndex: "response_raw_data",
      key: "response_raw_data",
      className: "text-capitalize",
      render: (value, item, index) => {
        const data = item?.response_raw_data
          ? JSON.parse(item?.response_raw_data)
          : null;

        return data ? (
          <span>
            {data.consent?.consentDetail?.requester?.name} (
            {data.consent?.consentDetail?.requester?.identifier?.value})
          </span>
        ) : null;
      }
    },

    {
      title: "Granted HI Types",
      dataIndex: "response_raw_data",
      key: "response_raw_data",
      className: "text-capitalize hiTypes_column",
      render: (value, item, index) => {
        let data = item?.response_raw_data
          ? JSON.parse(item?.response_raw_data)
          : "";
        const RequestedData = data.consent?.consentDetail?.hiTypes.map(
          (hiType, index) => <li key={index}>{hiType}</li>
        );
        return data ? (
          <div
            className="hiTypes_scroll"
            style={{ maxHeight: "100px", overflowY: "scroll" }}
          >
            <ul className="hiTypes">{RequestedData}</ul>
          </div>
        ) : (
          ""
        );
      }
    },
    {
      title: "Granted From Date",
      dataIndex: "response_raw_data",
      key: "response_raw_data",
      className: "date-w",
      render: (value, item, index) => {
        const data = item?.response_raw_data
          ? JSON.parse(item?.response_raw_data)
          : null;

        return data ? (
          <span>
            {dayjs(data.consent?.consentDetail?.permission?.dateRange?.from)
              .tz("Asia/Kolkata")
              .format("DD-MM-YY")}
          </span>
        ) : null;
      }
    },
    {
      title: "Granted To Date",
      dataIndex: "response_raw_data",
      key: "response_raw_data",
      className: "date-w",
      render: (value, item, index) => {
        const data = item?.response_raw_data
          ? JSON.parse(item?.response_raw_data)
          : null;

        return data ? (
          <span>
            {dayjs(data.consent?.consentDetail?.permission?.dateRange?.to)
              .tz("Asia/Kolkata")
              .format("DD-MM-YY")}
          </span>
        ) : null;
      }
    },
    {
      title: "Expiry Date Time",
      dataIndex: "response_raw_data",
      key: "response_raw_data",
      className: "date-w",
      render: (value, item, index) => {
        const data = item?.response_raw_data
          ? JSON.parse(item?.response_raw_data)
          : null;

        return data ? (
          <span>
            {moment
              .utc(data.consent?.consentDetail?.permission?.dataEraseAt)
              .local()
              .format("DD-MM-YY hh:mm:ss A")}
          </span>
        ) : null;
      }
    },
    {
      title: "Consent Status",
      dataIndex: "consent_status",
      key: "consent_status",
      className: "text-capitalize",
      render: (value, record, index) => {
        var expiryDateTime = null;
        var d = null;
        /*const expireDateTime = (expiryDate) => {
                    const date = moment(expiryDate, 'YYYY-MM-DD HH:mm:ss');
                    if (date.isBefore(currentDate)) {
                        return true;
                    } else {
                        return false;
                    }
                }*/

        var response_raw_data = JSON.parse(record?.response_raw_data);
        var dataEraseAt =
          response_raw_data?.consent.consentDetail?.permission?.dataEraseAt;
        //console.log(response_raw_data?.consent.consentDetail?.permission?.dataEraseAt);
        // console.log(dataEraseAt);

        return record?.consent_status == "DENIED" ||
          record?.consent_status == "REVOKED" ||
          record?.consent_status == "EXPIRED" ? (
          <span style={{ color: "red" }}>{record?.consent_status}</span>
        ) : record?.consent_status == "GRANTED" ? (
          <span style={{ color: "green" }}>{record?.consent_status}</span>
        ) : record?.consent_status != "GRANTED" &&
          record?.consent_status != "DENIED" &&
          expiryDateTime ? (
          <span style={{ color: "red" }}>EXPIRED</span>
        ) : (
          <span>{record?.consent_status}</span>
        );
      }
    },

    {
      title: "Date Time",
      dataIndex: "createdAt",
      key: "createdAt",
      className: "abha-link-date",
      render: (value, item, index) => {
        return <>{moment.utc(item.createdAt).format("DD-MM-YYYY H:mm:ss")}</>;
      }
    }

    // {
    //     title: 'Response Data',
    //     dataIndex: 'Status',
    //     key: 'Status',
    //     className: 'table_status_col',
    //     render: (value, item, index) => {
    //         return (
    //             // <Button className="view-btn" type="primary" onClick={() => { setRaw(JSON.parse(item?.response_raw_data || "{}")); setModal1Open(true); }} > View</Button>
    //             <Link to="/hiu/data-received"> View Data Received</Link>
    //             )
    //     }
    // },
  ];
  return (
    <div>
      <Row gutter={[10, 10]} align={"middle"}>
        <Col span={24}>
          <HeadingBack
            title={"Consent Artifact Details"}
            subHeading={`Records ${totalConsentArtifactDetails || 0}`}
          />
        </Col>
        <Col span={24}>
          <AbhaLinkedFilter
            filter={filter}
            setFilter={setFilter}
            setPage={setPage}
          />
        </Col>
      </Row>
      <div className="tableResponsive mt-10">
        <Table
          rowKey={(row) => row?.Id ?? row?.id}
          className="table antd_table"
          bordered
          columns={columns}
          scroll={{ x: "max-content" }}
          dataSource={
            Array.isArray(ConsentArtifactDetails) ? ConsentArtifactDetails : []
          }
          pagination={{
            current: page,
            pageSize: limit,
            total: totalConsentArtifactDetails,
            onChange: (current, pageSize) => {
              setPage(current);
              setLimit(pageSize);
            },
            showSizeChanger: true,
            showTotal: (total, range) =>
              `${range[0]}-${range[1]} of ${total} records`
          }}
        />
      </div>

      <Modal
        style={{
          top: 20
        }}
        open={modal1Open}
        onOk={() => setModal1Open(false)}
        onCancel={() => {
          setRaw({});
          setModal1Open(false);
        }}
        footer={null}
      >
        <pre>{JSON.stringify(raw, null, 2)}</pre>
      </Modal>
    </div>
  );
};

export default ConsentArtifactDetails;
